import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/shared/contexts/AuthContext';
import { useToast } from '@/shared/contexts';

export const HOME_SECTIONS = [
  { id: 'home', label: 'Início' },
  { id: 'noticias', label: 'Notícias' },
  { id: 'diferenciais', label: 'Diferenciais' },
  { id: 'ranking', label: 'Ranking' },
  { id: 'guerra', label: 'Guerra' },
  { id: 'download', label: 'Download' },
] as const;

export function SiteHeader() {
  const navigate = useNavigate();
  const { isLoggedIn, logout } = useAuth();
  const { setOpenVerify } = useToast();
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState('home');

  // Item ativo do menu acompanha a secao no meio da tela (mesma janela do original).
  useEffect(() => {
    const sections = HOME_SECTIONS.map((s) => document.getElementById(s.id)).filter(Boolean) as HTMLElement[];
    if (!sections.length) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) setActive(entry.target.id);
      });
    }, { rootMargin: '-35% 0px -52%' });
    sections.forEach((s) => io.observe(s));
    return () => io.disconnect();
  }, []);

  return (
    <header className="site-header" id="top">
      <div className="shell header-inner">
        <a className="brand" href="#home"><span>CABAL</span><b>LIBERTY</b></a>
        <button className="menu-toggle" aria-label="Abrir menu" onClick={() => setOpen((v) => !v)}><i></i><i></i><i></i></button>
        <nav className={`main-nav${open ? ' open' : ''}`}>
          {/* Cabecalho do menu mobile: acesso a Entrar/Cadastro (ou Painel/Sair) — o
              header-actions do topo some no mobile, entao sem isto nao dava pra logar. */}
          <div className="nav-account">
            {isLoggedIn ? (
              <>
                <Link className="btn btn-gold" to="/dashboard" onClick={() => setOpen(false)}><span>♙</span> Painel</Link>
                <button className="btn btn-dark" onClick={() => { setOpen(false); logout(); navigate('/'); }}><span>↪</span> Sair</button>
              </>
            ) : (
              <>
                <button className="btn btn-gold" onClick={() => { setOpen(false); setOpenVerify(true); }}><span>↪</span> Entrar</button>
                <Link className="btn btn-dark" to="/cadastro" onClick={() => setOpen(false)}><span>♙</span> Cadastro</Link>
              </>
            )}
          </div>
          {HOME_SECTIONS.map((s) => (
            <a key={s.id} className={active === s.id ? 'active' : undefined} href={`#${s.id}`} onClick={() => setOpen(false)}>
              {s.label}
            </a>
          ))}
        </nav>
        <div className="header-actions">
          {isLoggedIn ? (
            <>
              <button className="btn btn-dark" onClick={() => { logout(); navigate('/'); }}><span>↪</span> Sair</button>
              <Link className="btn btn-gold" to="/dashboard"><span>♙</span> Painel</Link>
            </>
          ) : (
            <>
              <button className="btn btn-dark" onClick={() => setOpenVerify(true)}><span>↪</span> Entrar</button>
              <Link className="btn btn-gold" to="/cadastro"><span>♙</span> Cadastro</Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
